import dayjs from 'dayjs';
import { memo, useMemo } from 'react';

import { Box, Flex, Paper, Text, Title } from '@mantine/core';

import { CheckCarAccessResponseType } from '@/types/car-access';
import { IObject } from '@/types/object';

interface CarAccessInfoProps {
	data: CheckCarAccessResponseType;
}

function CarAccessInfo({ data }: CarAccessInfoProps) {
	const {
		car_acess,
		object_name,
		car_number,
		full_name,
		is_guest,
		is_vip,
		booking_start,
		booking_finish,
	} = data;

	return (
		<Paper mt={20} p={15} withBorder>
			<Flex justify="space-between" gap="xs">
				<Box w="25%">
					<Title order={5}>Объект:</Title>
					<Text c={object_name ? 'green' : 'red'}>{object_name ?? 'Не опредлен'}</Text>
				</Box>
				<Box w="25%">
					<Title order={5}>Проезд:</Title>
					<Text c={car_acess ? 'green' : 'red'}>{car_acess ? 'разрешен' : 'запрещен'}</Text>
				</Box>
				<Box w="25%">
					<Title order={5}>ФИО:</Title>
					<Text>{full_name ?? 'Не опредлено'}</Text>
				</Box>
				<Box w="25%">
					<Title order={5}>Номер авто:</Title>
					<Text>{car_number}</Text>
				</Box>
			</Flex>
			<Flex justify="space-between" mt={10} gap="xs">
				<Box w="25%">
					<Title order={5}>Гость:</Title>
					<Text c={is_guest ? 'green' : 'red'}>{is_guest ? 'Гость' : 'Штатный сотрудник'}</Text>
				</Box>
				<Box w="25%">
					<Title order={5}>VIP:</Title>
					<Text c={is_vip ? 'green' : 'red'}>{is_vip ? 'Да' : 'Нет'}</Text>
				</Box>
				<Box w="25%">
					<Title order={5}>Начало:</Title>
					<Text>{dayjs(booking_start).format('DD.MM.YYYY HH:mm')}</Text>
				</Box>
				<Box w="25%">
					<Title order={5}>Конец:</Title>
					<Text>{dayjs(booking_finish).format('DD.MM.YYYY HH:mm')}</Text>
				</Box>
			</Flex>
		</Paper>
	);
}

export default memo(CarAccessInfo);
